// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"92e7bf72","151":"1d725683","585":"c54f6624"}[chunkId] + ".chunk.js";
};